import React, { useState, useEffect, useMemo, useRef } from "react";
import { getDomainAndClientWiseAccounts } from "../../../services/commonService";
import { useUser } from "../../../context/UserContext";
import { COMPANY_LOGO_BASE_URL, PROJECT_DISPLAY_NAME } from "../../../config/apiConfig";
import { Link, useNavigate } from "react-router-dom";
// import ScreenLoader from "../../HtmlElements/ScreenLoader"; // ❌ remove full-page loader
import { Button } from "react-bootstrap";
import * as FeatherIcon from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../../HtmlElements/Alert";
import AddDemoRequest from "../../DemoRequests/AddDemoRequest";
import { saveCheckoutClientInfo } from "../../../services/authService";
import "./AllSalesAccounts.css"
import { resetAllAccDepen } from "../../../store/features/actions/commonActions";
import Multiselect from 'multiselect-react-dropdown';
import api from "../../../services/api";
import OpportunityFilterComponent from "../AccountDetails/Opportunities/opportunityFilterContainer/OpportunityFilterComponent";
import AccountLogo from "./AccountLogo";
import { useBanner } from "../../../context/BannerContext";

/* ---------------- Skeleton Components ---------------- */
function SkeletonLine({ width = "100%", height = 12, className = "" }) {
  return <div className={`skel-line ${className}`} style={{ width, height }} />;
}

function IndustrySkeleton({ count = 6 }) {
  return (
    <ul className="list_trends_ul">
      {Array.from({ length: count }).map((_, i) => (
        <li key={i} className="list_trends_li">
          <div className="skel-avatar sm" />
          <SkeletonLine width="70%" />
        </li>
      ))}
    </ul>
  );
}

function ClientSkeleton({ count = 8 }) {
  return (
    <ul className="client_list_trends_ul">
      {Array.from({ length: count }).map((_, i) => (
        <li key={i} className="client_list_trends_li">
          <SkeletonLine width="80%" />
        </li>
      ))}
    </ul>
  );
}

function AccountsSkeleton({ count = 8 }) {
  return (
    <div className="row">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="col-md-3">
          <div className="logo_block skel-card">
            <div className="com_logo">
              <div className="skel-avatar lg" />
            </div>
            <div className="com_name_block">
              <SkeletonLine width="90%" height={14} />
              <SkeletonLine width="60%" height={12} className="mt-1" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
/* ----------------------------------------------------- */

export default function AllSalesAccounts() {
  const dispatch = useDispatch();

  const showBanner = useBanner();


  const { user, setUser } = useUser();
  const navigate = useNavigate();

  const [domainWiseClientsAndAccounts, setDomainWiseClientsAndAccounts] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  const [selectedDomainIndex, setSelectedDomainIndex] = useState(null); // number | null
  const [selectedClient, setSelectedClient] = useState({
    code: null,
    name: null,
    ksCode: null,
    ksName: null,
  });

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [showDescriptionModal, setShowModal] = useState(false);
  const [success_message, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [accountsIndustries, setAccountsIndustries] = useState([])
  const [companyTypeOptions, setCompanyTypeOptions] = useState([{'display_name': 'Public'}, {'display_name': 'Private'}])
  const [selectedIndustries, setSelectedIndustries] = useState([])
  const [selectedCompanyTypes, setSelectedCompanyTypes] = useState([])
  const [isPublic, setIsPublic] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [filterOptions, setFilterOptions] = useState({})
  const [filters, setFilters] = useState({})
  const dropdownRef = useRef();

  useEffect(() => {
    // Fetch company list from the API
    const fetchAccountIndustries = async () => {
      try {
        const response = await api.get('/accounts/get_distinct_accounts_industries', {})
        let industries = [...response.data.result.list] ;
        industries = industries.map(industry => {
          return {
              display_name: industry
          };
        });

        setAccountsIndustries(industries); // Assuming the response contains an array of users
      } catch (error) {
        console.error('Error fetching industries:', error);
      }
    };
    fetchAccountIndustries();
  }, []);

  useEffect(() => {

    let accountsIndustriesArr = accountsIndustries.map((data) => data.display_name)
    let companyTypeOptionsArr = companyTypeOptions.map((data) => data.display_name)
    const tmpOptions = {
      'account_industries': accountsIndustriesArr,
      'company_type': companyTypeOptionsArr,
    }
    setFilterOptions(tmpOptions);

  }, [accountsIndustries, companyTypeOptions])

  // 🧠 Handle outside click to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChangeMultiSelect = (accountsmgrArr) => {
    const newAccountMgr = accountsmgrArr.map((accountsmgrObj) => {
      return accountsmgrObj
    });
    setSelectedIndustries(newAccountMgr);
  }
  // const handleChangeMultiSelectCompanyType = (companyTypes) => {
  //   const selectedCompanyTypes = companyTypes.map((companyType) => {
  //     return companyType
  //   });
  //   setSelectedCompanyTypes(selectedCompanyTypes)
  // }

  // const handleCheckboxChange = (e) => {
  //   const { value, checked } = e.target;
  //   if (value === "public") {
  //     setIsPublic(checked);
  //   } else if (value === "private") {
  //     setIsPrivate(checked);
  //   }
  // };

  const handleRemoveMultiSelect = (selectedList) => {
    const selectedIds = selectedList.map(item => item);
    setSelectedIndustries(selectedIds);
  };

  // Debounce search
  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(search.trim()), 500);
    return () => clearTimeout(t);
  }, [search]);

  // Fetch domains + clients (+ accounts) when role is SALES_DEMO or search changes
  useEffect(() => {
    let cancelled = false;
    async function load() {
      if (user?.role_key !== "SALES_DEMO" &&  user?.role_key !== "ANALYST") return;
      setIsFetching(true);

      const account_industries = selectedIndustries.map((row => row.display_name))

      try {

        // const companyTypesArr = selectedCompanyTypes.map((d) => d.display_name )

        const account_industries = filters?.account_industries || []
        const companyTypesArr = filters?.company_type || []

        var isPublic = false;
        if(companyTypesArr.indexOf('Public') != -1){
          isPublic = true
        }

        var isPrivate = false;
        if(companyTypesArr.indexOf('Private') != -1){
          isPrivate = true
        }

        const data = await getDomainAndClientWiseAccounts(debouncedSearch, account_industries, isPublic, isPrivate);
        if (cancelled) return;
        setDomainWiseClientsAndAccounts(Array.isArray(data) ? data : []);
        // Reset selections on new data
        if (Array.isArray(data) && data.length > 0) {
          setSelectedDomainIndex(0);
          const firstClient = data[0]?.clients?.[0];
          setSelectedClient({
            code: firstClient?.client_code ?? null,
            name: firstClient?.client_name ?? null,
            ksCode: firstClient?.ks_company_code ?? null,
            ksName: firstClient?.ks_company_name ?? null,
          });
        } else {
          setSelectedDomainIndex(null);
          setSelectedClient({ code: null, name: null, ksCode: null, ksName: null });
        }
      } finally {
        if (!cancelled) setIsFetching(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [user?.role_key, debouncedSearch, filters]);

  // Select a domain (keep type consistent)
  const handleSelectedDomainIndex = (idx) => {
    if (typeof idx !== "number") return;
    setSelectedDomainIndex(idx);
    const firstClient = domainWiseClientsAndAccounts[idx]?.clients?.[0];
    setSelectedClient({
      code: firstClient?.client_code ?? null,
      name: firstClient?.client_name ?? null,
      ksCode: firstClient?.ks_company_code ?? null,
      ksName: firstClient?.ks_company_name ?? null,
    });
  };

  // Select a client
  const handleSelectClient = (account_code, account_name, ks_company_code, ks_company_name) => {
    setSelectedClient({
      code: account_code,
      name: account_name,
      ksCode: ks_company_code,
      ksName: ks_company_name,
    });
  };

  // Derived account list
  const accountList = useMemo(() => {
    if (selectedDomainIndex === null) return [];
    const domain = domainWiseClientsAndAccounts[selectedDomainIndex];
    if (!domain?.clients?.length) return [];
    const idx = domain.clients.findIndex(c => c.client_code === selectedClient.code);
    const client = idx >= 0 ? domain.clients[idx] : domain.clients[0];
    return client?.accounts ?? [];
  }, [domainWiseClientsAndAccounts, selectedDomainIndex, selectedClient.code]);

  const handleCheckoutToAccounts = () => {
    const { code, name, ksCode, ksName } = selectedClient;
    if (!code || !name) return;

    saveCheckoutClientInfo(code, name, ksCode, ksName);
    const checkoutClientInfo = (function() {
      try { return JSON.parse(localStorage.getItem("checkoutClientInfo")); } catch { return null; }
    })();
    setUser(prev => ({ ...prev, checkoutClientInfo }));
    navigate(`/clients_accounts/${code}/${name}`);
  };

  const goToAccountDetails = (account_id, account_name) => {
    const { code, name, ksCode, ksName } = selectedClient;
    if (!code || !name) return;

    saveCheckoutClientInfo(code, name, ksCode, ksName);
    const checkoutClientInfo = (function() {
      try { return JSON.parse(localStorage.getItem("checkoutClientInfo")); } catch { return null; }
    })();
    setUser(prev => ({ ...prev, checkoutClientInfo }));
    navigate(`/account_details/${account_id}/${encodeURIComponent(account_name)}/${encodeURIComponent(name)}`);
  };

  // Toasts for demo-request reducer messages
  /*
  const hasMounted = useRef(false);
  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }
    if (successMessage?.data?.result?.message === "Demo request added successfully") {
      setSuccessMessage("Request added successfully !");
      const t = setTimeout(() => setSuccessMessage(""), 4000);
      return () => clearTimeout(t);
    }
  }, [successMessage]);

  useEffect(() => {
    if (!hasMounted.current) return;
    if (errorMessage) {
      setError(errorMessage);
      const t = setTimeout(() => setError(""), 4000);
      return () => clearTimeout(t);
    }
  }, [errorMessage]);
  */

  const handleClose = () => setShowModal(false);

  return (
    <div>
      <div className="new_login_page">
        <div className="container-fluid sales-play-demo-accounts-page">
          {/* No full-page loader; skeletons render inline below */}

          <div className="row">
            <div className="col-md-12 align-right">
              {(success_message || error) && <>
                <div className="col-md-12 pt-2 mr-2" style={{ textAlign: "center" }}>
                  {success_message && <Alert type="success" message={success_message} />}
                  {error && <Alert type="danger" message={error} />}
                </div>
              </>
              }

              <div className="row">
                <div className="col-md-6">
                  <div className="new_search_custom mr-4" style={{width: '85px', display: "inline-block", }}>
                  <div className="filter-container" ref={dropdownRef}>
                    <div className="filter-dropdown" key={`filters_container_${JSON.stringify(filters)}`} >
                      <button
                        className="custom-dropdown-toggle"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setIsDropdownOpen((prev) => !prev);
                        }}
                      >
                        Filter
                        {Object.entries(filters).reduce(
                          (sum, [key, value]) => sum + (value?.length || 0),
                          0
                        ) > 0 && (
                          <>
                            ({Object.entries(filters).reduce(
                              (sum, [key, value]) => sum + (value?.length || 0),
                              0
                            )})
                          </>
                        )}
                        <img src="/img/chevron-down.svg" />
                      </button>
                      {isDropdownOpen && (
                        <div className={`dropdown-content show`} style={{
                          // left: '230px',
                          textAlign: 'left'
                        }}>
                            <OpportunityFilterComponent
                              key={`filters_container_comp_${JSON.stringify(filters)}`}
                              filterOptions={filterOptions || []}
                              filters={filters}
                              setFilters={setFilters}
                              loading={false}
                              setIsDropdownOpen={setIsDropdownOpen}
                            />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="new_search_custom ml-2" style={{ display: "inline-block" }}>
                  <input
                    type="text"
                    className="sales_search_input"
                    name="search_string"
                    placeholder="Search by Seller Companies or Target Account"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    autoComplete="off"
                  />
                  <FeatherIcon.Search className="seach_new_login" />
                </div>
              </div>

              <div className="col-md-6 pt-2 request_demo_link_container">
              {user?.role_key === "SALES_DEMO" && (
                <>
                    <Link className="request_demo_link" to="/demo_requests">My Requests</Link>
                    {/* <span className="request_demo_link ml-2 mr-1" onClick={() => setShowModal(true)}>
                      Request Demo
                    </span> */}
                    <span className="pt-1 ml-1 mr-1" style={{
                      verticalAlign: '-webkit-baseline-middle'
                    }}> | </span>
                    <Link className="request_demo_link  mr-1" to="/demo_requests/request_demo">Request Demo</Link>
                </>
              )}
              </div>

              {/* <div className="new_search_custom mr-1  float-left pl-1" style={{ display: "inline-block", width: '180px'}}>
                  <Multiselect
                    options={companyTypeOptions}
                    onSelect={handleChangeMultiSelectCompanyType}
                    onRemove={handleChangeMultiSelectCompanyType}
                    displayValue="display_name"
                    showCheckbox="true"
                    placeholder={
                      selectedCompanyTypes.length > 0
                        ? `${selectedCompanyTypes.length} company type selected`
                        : "Select company type"
                    }
                    style={{
                      chips: { display: "none" }, // hide default tags
                      multiselectContainer: { width: "100%" },
                    }}
                    ></Multiselect>
              </div> */}

              {/* <div className="new_search_custom multiselect-custom mr-1 ml-1 float-left">
                  <Multiselect
                    options={accountsIndustries}
                    onSelect={handleChangeMultiSelect}
                    onRemove={handleRemoveMultiSelect}
                    displayValue="display_name"
                    showCheckbox="true"
                    placeholder={
                      selectedIndustries.length > 0
                        ? `${selectedIndustries.length} account industries selected`
                        : "Select Account Industries"
                    }
                    style={{
                      chips: { display: "none" }, // hide default tags
                      multiselectContainer: { width: "100%" },
                    }}
                    ></Multiselect>
                </div> */}              

              </div>
            </div>
          </div>

          <div className="custom_card_block">
            {domainWiseClientsAndAccounts.length > 0 || isFetching ? (
              <div className="three_block_flex">
                {/* Seller Industry */}
                <div className="industry_block">
                  <div className="div_head">
                    <h5 className="head">Seller Industry</h5>
                  </div>
                  <div className="list_ind_block">
                    {isFetching && domainWiseClientsAndAccounts.length === 0 ? (
                      <IndustrySkeleton />
                    ) : (
                      <ul className="list_trends_ul">
                        {domainWiseClientsAndAccounts.map((domainData, index) => {
                          const domainImage = String(domainData.company_domain || "")
                            .toLowerCase()
                            .replace(/[^a-z0-9]+/g, "_");
                          const active = index === selectedDomainIndex;
                          return (
                            <li
                              key={`domain_key_${index}`}
                              className={`list_trends_li ${active ? "active" : ""}`}
                              onClick={() => handleSelectedDomainIndex(index)}
                            >
                              <img
                                src={`/img/indu_icon/${domainImage}.png`}
                                alt="icon"
                                className="icon"
                                onError={(e) => { e.currentTarget.style.visibility = "hidden"; }}
                              />
                              <span className="trend_name">
                                {domainData.company_domain} ({domainData.clients_count})
                              </span>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </div>
                </div>

                {/* Seller Company */}
                <div className="clients_block">
                  <div className="div_head">
                    <h5 className="head">Seller Company</h5>
                  </div>
                  <div className="client_list_ind_block">
                    {isFetching && domainWiseClientsAndAccounts.length === 0 ? (
                      <ClientSkeleton />
                    ) : (
                      <ul className="client_list_trends_ul">
                        {selectedDomainIndex !== null &&
                          domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.map((clientData, index) => {
                            const active = clientData.client_code === selectedClient.code;
                            return (
                              <li
                                key={`client_list_key_${index}`}
                                className={`client_list_trends_li ${active ? "active" : ""}`}
                                onClick={() =>
                                  handleSelectClient(
                                    clientData?.client_code,
                                    clientData?.client_name,
                                    clientData?.ks_company_code,
                                    clientData?.ks_company_name
                                  )
                                }
                              >
                                <span className="client_trend_name">
                                  {clientData?.client_name} ({clientData?.account_count})
                                </span>
                              </li>
                            );
                          })}
                      </ul>
                    )}
                  </div>
                </div>

                {/* Target Accounts */}
                <div className="sales_block">
                  <div className="div_head d-flex justify-content-between">
                    <h5 className="head">Target Accounts</h5>
                    <Button
                      className="btn-checkout-accounts btn btn-sm mr-1"
                      onClick={handleCheckoutToAccounts}
                      disabled={!selectedClient.code}
                    >
                      {PROJECT_DISPLAY_NAME} <FeatherIcon.ArrowRight className="fa" />
                    </Button>
                  </div>

                  <div className="sales_list_block">
                    {isFetching && (
                      <AccountsSkeleton />
                    )}

                    {!isFetching && (
                      <div className="row">
                        {selectedDomainIndex !== null && accountList?.length > 0 ? (
                          accountList.map((accountData, index) => (

                            <div
                              key={`account_list_key_${index}`}
                              className="col-md-3 cursorP"
                              onClick={(e) =>{
                                e.preventDefault();
                                dispatch(resetAllAccDepen());
                                goToAccountDetails(accountData._id, accountData.account_name)}}
                            >
                              <div className="logo_block">
                                <AccountLogo 
                                  key={`account_img_comp_${accountData.account_name}`}
                                  account_name={accountData.account_name}
                                 />
                                <div className="com_name_block">
                                  <h5 className="comp_name">
                                    <span
                                      className="account_title_link cursorP"
                                      onClick={() => goToAccountDetails(accountData._id, accountData.account_name)}
                                    >
                                      {accountData?.account_name}
                                    </span>
                                  </h5>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="col-md-12 text-center py-4">
                            No accounts found.
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              !isFetching && (
                <div className="mb-3 ml-4 text-center" style={{ minHeight: "350px" }}>
                  No Client or Account found.
                </div>
              )
            )}
          </div>
        </div>
      </div>

      {showDescriptionModal && <AddDemoRequest handleClose={handleClose} />}
    </div>
  );
}
